import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import { ModalContainer } from 'components/Modals/ModalContainer';
import { LoginForm } from 'components/Forms/LoginForm/LoginForm';
import { RegistrationForm } from 'components/Forms/RegistrationForm/RegistrationForm';
import { AUTH_MODAL_DATA } from 'shared/constants/modal-constants';
import { closeCurrentModal } from 'redux/slices/modals/modals.slice';
import { useAppDispatch, useAppSelector } from 'redux/hooks/reduxHooks';
import { selectCurrentModal } from 'redux/selectors/selectors';
import { EModalsNames } from 'shared/types/modal.interface';
import { TabData } from 'shared/types/common.interface';
import TabsComponent from 'components/Tabs/TabsComponent/TabsComponent';

export const AuthModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentModal = useAppSelector(selectCurrentModal);

  const AUTH_MODAL_COMPONENTS: TabData[] = [
    {
      label: AUTH_MODAL_DATA.tabSignIn,
      component: <LoginForm />,
    },
    {
      label: AUTH_MODAL_DATA.tabSignUp,
      component: <RegistrationForm />,
    },
  ];

  if (currentModal.entityName !== EModalsNames.AuthModal) return null;

  return (
    <ModalContainer
      onClose={() => dispatch(closeCurrentModal())}
      isOpen={currentModal.entityName === EModalsNames.AuthModal}
    >
      <Stack alignItems="center" width="100%">
        <Typography variant="h2" sx={{ color: 'primary.main' }}>
          {AUTH_MODAL_DATA.title}
        </Typography>
        {currentModal.data.subtitle && (
          <Typography variant="subtitle1" color="primary.main" sx={{ p: '8px 0 0' }}>
            {currentModal.data.subtitle}
          </Typography>
        )}
        <TabsComponent
          components={AUTH_MODAL_COMPONENTS}
          sx={{ mt: { lg: '48px', md: '40px', sm: '40px', xs: '40px' } }}
        />
      </Stack>
    </ModalContainer>
  );
};
